import React from "react";

const MovedBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800 ${className}`}
  >
    Moved
  </span>
);

export default MovedBadge;
